/**
 * Product availability utilities
 */

import { IAvailabilityResponse } from 'components/Catalog/Product/Interfaces/IAvailability';
import { PRODUCT_TYPES } from '../constants/product.constants';

/**
 * Checks if availability data should be shown for a product
 * @param productType - The type of the product
 * @param hasSelectedProduct - Whether a configurable product variant is selected
 * @param availabilityConfig - Availability configuration
 * @returns Whether availability should be displayed
 */
export const shouldShowAvailability = (
    productType: string,
    hasSelectedProduct: boolean,
    availabilityConfig?: { availabilityLabel: string; items: IAvailabilityResponse[] },
): boolean => {
    if (!availabilityConfig) {
        return false;
    }

    // Show for simple products or when a configurable product variant is selected
    return productType === PRODUCT_TYPES.SIMPLE_PRODUCT_TYPE || hasSelectedProduct;
};
